import { Component } from '@angular/core';

@Component({
    selector: 'project-main-view',
    template: require('../templates/project.main.html')
})
export class ProjectMainViewComponent {}
